<template>
  <page v-if="team">
    <nav class="breadcrumb">
      <ul class="breadcrumb__list">
        <li class="breadcrumb__item">
          <router-link
            v-t="'p.teamPage.title'"
            :to="{ name: 'Teams' }"
            class="breadcrumb__link"
          />
        </li>
      </ul>
    </nav>
    <page-title>{{ team.name }}</page-title>
    <nav-bar>
      <nav-bar-link
        :to="{ name: 'TeamSettings' }"
        :label="$t('p.teamPage.navigation.settings')"
        icon="cog"
      />

      <nav-bar-link
        :to="{ name: 'TeamMembers' }"
        :label="$t('p.teamPage.navigation.members')"
        icon="users"
      />
    </nav-bar>
    <router-view />
  </page>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import NavBarMixin from '@/mixins/ui/NavBar'
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'TeamPage',
  mixins: [NavBarMixin, PageMixin],
  computed: {
    ...mapState({
      team: state => state.team.team
    })
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler ($route) {
        if ($route.path === '/settings') {
          this.$router.push({ name: 'TeamSettings' })
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchTeam',
      'resetTeam'
    ])
  },
  created () {
    const teamId = this.$route.params.teamId
    this.fetchTeam(teamId)
      .then(() => {
        this.$emit('loadingDone')
        this.$router.push({ name: 'TeamSettings' })
      })
  },
  beforeDestroy () {
    // this.resetTeam()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/teams/TeamPage.vue